var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { attrs: { dense: "", id: "continue" } },
    [
      _vm._l(_vm.shownGroupings, function (shownGroup, index) {
        return [
          _c(
            "v-subheader",
            { key: `group-subheader-${index}` },
            [
              _vm._v("\n      " + _vm._s(shownGroup.name) + "\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.isTenantAdmin
                ? _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleEditSettings(shownGroup.sourceType)
                        },
                      },
                    },
                    [
                      _vm.groupStates[shownGroup.sourceType].editing
                        ? _c(
                            "v-icon",
                            { attrs: { color: "error lighten-1" } },
                            [_vm._v("close")]
                          )
                        : _c("v-icon", [_vm._v("edit")]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.groupStates[shownGroup.sourceType].editing && _vm.isTenantAdmin
            ? [
                _c(
                  "v-card",
                  { key: `group-edit-card-${index}` },
                  [
                    _c(
                      "v-card-actions",
                      { staticStyle: { "padding-bottom": "0px" } },
                      [
                        _c("v-subheader", { staticClass: "removePadding" }, [
                          _vm._v("Group stations:"),
                        ]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              small: "",
                              color: "secondary",
                              loading:
                                _vm.groupStates[shownGroup.sourceType].loading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.save(shownGroup.sourceType)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("Button.apply")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      { staticStyle: { "padding-top": "0px" } },
                      [
                        _c("v-combobox", {
                          attrs: {
                            items: _vm.groupStates[shownGroup.sourceType].items,
                            "menu-props": { offsetX: true, nudgeTop: 45 },
                            solo: "",
                            chips: "",
                            label: "Select group",
                            multiple: "",
                            "persistent-hint": "",
                            "item-text": "name",
                            "item-value": "name",
                            "return-object": "",
                            "deletable-chips": "",
                          },
                          model: {
                            value:
                              _vm.groupStates[shownGroup.sourceType].selected,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.groupStates[shownGroup.sourceType],
                                "selected",
                                $$v
                              )
                            },
                            expression:
                              "groupStates[shownGroup.sourceType].selected",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          shownGroup.group
            ? _c("SideMenuGrouper", {
                key: `group-side-menu-grouper-${index}`,
                attrs: {
                  groups: shownGroup.group,
                  groupSettings: _vm.sideMenuSettings[shownGroup.sourceType],
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-divider", { key: `group-divider-${index}` }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }